import "babel-polyfill";
import React from 'react';
import PropTypes from 'prop-types'; 

import ImageHelpers from '../util/aws';
import ImageCompressor from 'image-compressor.js';

import { contactUsTicketEndpoint, integrityEndpoints } from '../util/endpoints';

export default class ContactForm extends React.Component {
  state = {
    uploading: false,
    sending: false,
    sent: false,
    fields: this.props.fields || [],
    images: [],
    requireUploadError: false,
    ticketCreateMsg: false,
    isIntegrityEndpoint: this.props.isIntegrityEndpoint,
    tags: [
      window.currentCountry().toLowerCase(),
      this.props.groupName.replace(/ /g, '').toLowerCase(),
    ],
  }

  handleUpload = async (e) => {
    this.imageCompressor = this.imageCompressor|| new ImageCompressor();

    const file = await this.imageCompressor.compress(e.target.files[0], {
      quality: 1,
      maxWidth: 900,
      maxHeight: 900
    })

    this.setState({uploading: true})

    if (file) {
      const { url, fileKey } = await ImageHelpers.signAndUpload(file, file.type, "contactUsSigEndpoint")
      console.log(url);
      
      this.setState((oldState) => {
        return {uploading: false, images: [...oldState.images, {url: url, object_key: fileKey}]}
      })
    }
  }

  handleSubmit = (e) => {
    e.preventDefault()
    let errorCount = 0

    const checkedFields = this.state.fields.map((field) => {
      console.log("field: ", field.ref)
      const val = this.refs[field.ref].value
      console.log("val: ", val)
      if (field.ref == "choice" && this.refs[field.ref].value.length == 0) {
        field.requiredError = true
        errorCount += 1
      } else if (field.type == "checkbox" && field.required && !this.refs[field.ref].checked) {
        field.requiredError = true
        errorCount += 1
      } else if (field.required && val.length == 0) {
        field.requiredError = true
        errorCount += 1
      } else {
        field.requiredError = false
      }
      return field
    })

    if (errorCount > 0) {
      this.setState({fields: checkedFields})
      return false;
    }

    if (this.props.requireUpload && this.state.images.length <= 0) {
      this.setState({requireUploadError: true})
      return false;
    } else {
      this.setState({ requireUploadError: false })
    }

    const data = {
      groupId: this.props.groupId,
      images: this.state.images,
      tags: this.state.tags,
    }

    this.state.fields.forEach((field) => {
      data[field.ref] = this.refs[field.ref].value
    })

    if (data["appraisalCode"]) {
      data["message"] += "\n\nAppraisal code: " + data["appraisalCode"]
    }

    this.setState({ sending: true })

    if (this.state.isIntegrityEndpoint) {
      let form = document.querySelector('#integrity-form');

      $.ajax({
        type: "POST", 
        url: integrityEndpoints[this.refs["choice"].value],
        data: $(form).serialize()
      }).done((res) => {
        if (res.status == "success") {
          this.setState({ sending: false, sent: true, ticketCreateMsg: "Your information has been submitted successfully!" })
        } else {
          this.setState({ sending: false, sent: false, ticketCreateMsg: "Sorry there was an error! Please check your email address, or email info@charmedaroma.com." }) 
        }
      })
    } else {
      $.ajax({
        headers: {
          "Content-Type": "application/json",
          "X-Api-Key": "93cR4NgVmn2Eubts6MKJTQaUgOG9hwM89P6K3ym8"
        },
        type: "POST",
        url: contactUsTicketEndpoint,
        data: JSON.stringify(data)
      }).done((res) => {
        if (res.ok) {
          this.setState({ sending: false, sent: true, ticketCreateMsg: "Your ticket has been created successfully!" })
        } else {
          this.setState({ sending: false, sent: false, ticketCreateMsg: "Sorry there was an error! Please check your email address, or upload fewer or smaller images, or email info@charmedaroma.com." })
        }
      });
    }
  }

  handleInputUpdate = (e) => {
    const input = $(e.target)
    if (input.attr("name").includes("order") && input.val() && input.val().includes("@")) {
      input.val("");
    }
  }

  fieldEl = (field) => {
    switch (field.type) {
      case "subject":
        return <input
          hidden
          type="text"
          ref={field.ref}
          defaultValue={field.value}
          autocomplete="off"
          name={`contact[${field.ref}]`} />
      case "text":
        return <input 
          type="text" 
          ref={field.ref} 
          autocomplete={field.autocomplete || "off"}
          name={`contact[${field.ref}]`} 
          onChange={this.handleInputUpdate}
          placeholder={field.placeholder + (field.required ? " (required)" : " (optional)") } />
      case "email":
        return <input 
          type="email" 
          ref={field.ref}
          name={`contact[${field.ref}]`}
          placeholder={field.placeholder + (field.required ? " (required)" : " (optional)")} />
      case "textarea":
        return <textarea 
          rows="15" 
          cols="75" 
          ref={field.ref} 
          name={`contact[${field.ref}]`} 
          placeholder={field.placeholder}></textarea>
      case "checkbox":
        return <div className="contactCheckbox">
          <input
          type="checkbox"
          ref={field.ref}
          name={`contact[${field.ref}]`}>
          </input>
          &nbsp;
          <label for={`contact[${field.ref}]`}>{field.label}</label>
        </div>
      case "dropdown":
        return <div className="styled-country-select slate" style={{width: "100%"}}>
          <select name={`contact[${field.ref}]`} ref={field.ref} className="slate" style={{ width: "100%" }}>
            {this.props.children.filter((c) => c.props.className.includes(field.ref))}
          </select>
        </div>
    }
  }

  render() {
    return (
      <React.Fragment >
        {this.props.allowUploads &&
          <div style={{textAlign: "center"}}>
            <p id="status">Please attach a photo or two of the issue {this.props.requireUpload ? "(required)" : "(optional)"}</p>
            <input type="file" onChange={this.handleUpload} />
            <div id="previews" style={{margin: "10px"}}>
              {this.state.images.map((image, i) => 
                <img key={i} style={{width: "100px", margin: "5px"}} src={image.url} />
              )}
              <img className="loader" style={{ display: this.state.uploading ? "inline" : "none", marginLeft: "15px" }} src={settings.loading} />
            </div>
          </div>
        }

        <form id={this.state.isIntegrityEndpoint ? "integrity-form" : null} onSubmit={this.handleSubmit}>
          {this.state.fields.map((field, i) => 
            <p key={i}>
              {this.fieldEl(field)}
              {field.requiredError && 
                <div style={{color: "red"}}>{field.placeholder} is required</div>
              }
            </p>
          )}
          <p className="buttons">
            {!this.state.sending && !this.state.sent &&
              <input type="submit" id="contactFormSubmit" className="large-button" value="SEND" />
            }
            {(this.state.sending || this.state.sent) &&
              <input type="submit" id="contactFormSubmitDisabled" className="large-button" disabled="disabled" value={this.state.sent ? "SENT" : "SENDING"} />
            }
            <br />
            <span className="error">
              {this.state.requireUploadError && <span>Please upload an image</span>}
              {this.state.ticketCreateMsg && <span>{this.state.ticketCreateMsg}</span>}
            </span>
          </p>
        </form>
      </React.Fragment>
    )
  }
}

ContactForm.propTypes = {
  groupId: PropTypes.string.isRequired,
  groupName: PropTypes.string.isRequired,
  fields: PropTypes.array.isRequired,
}